import imageConfig from "config/imageConfig";

export const getLocalFile = (name) => {
  return name ? `${imageConfig.baseURL}${imageConfig.postMedia}/${name}` : "";
};
